import { Box, Typography } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  flippedWords: string[];
}

const TextFlipper = ({ flippedWords }: Props) => {
  const { t } = useTranslation();
  const [index, setIndex] = useState<number>(0);

  useEffect(() => {
    const interval = setInterval(
      () => setIndex((prev) => (prev + 1) % flippedWords.length),
      2000
    );

    return () => clearInterval(interval);
  }, [flippedWords.length]);

  return (
    <Box
      sx={{
        display: "inline-block",
        height: "2em",
        overflow: "hidden",
      }}
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={flippedWords[index]}
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "-100%", opacity: 0 }}
          transition={{ duration: 0.7 }}
        >
          <Typography variant="h5" fontWeight={600}>
            {t(flippedWords[index])}
          </Typography>
        </motion.div>
      </AnimatePresence>
    </Box>
  );
};

export default TextFlipper;
